/**
 * HTTP notify PartyKit (pós-persistência) — sem WebSocket / circuit.
 * SRP: empurrar eventos para peers antes do eco do webhook.
 */
import { getValidAccessToken } from '../../../lib/supabase';
import { isValidPartykitHost, PARTYKIT_HOST } from './partykitHost';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

async function postParty(path: string, body: Record<string, unknown>): Promise<boolean> {
    if (!isValidPartykitHost()) return false;
    try {
        const res = await fetch(`https://${PARTYKIT_HOST}${path}`, {
            method: 'POST',
            headers: { ...JSON_HEADERS, Authorization: `Bearer ${await getValidAccessToken()}` },
            body: JSON.stringify({ ...body, timestamp: new Date().toISOString() }),
            signal: AbortSignal.timeout(5_000),
        });
        return res.ok;
    } catch {
        return false;
    }
}

export async function postPartykitOrgEvent(
    organizationId: string,
    party: 'status' | 'sync',
    body: Record<string, unknown>,
): Promise<boolean> {
    if (!organizationId) return false;
    const room = party === 'status' ? `org-${organizationId}` : organizationId;
    return postParty(`/parties/${party}/${room}`, { ...body, organizationId });
}

/** Avisa peers após persistência local (antes do eco do webhook). */
export async function notifyPartykitLocalMessage(options: {
    conversationId: string;
    organizationId: string;
    messageId: string;
    fromMe?: boolean;
    content?: string;
    messageType?: string;
    messageTimestamp?: string | Date;
}): Promise<void> {
    const { conversationId, organizationId, messageId } = options;
    if (!conversationId || !organizationId || !messageId || !isValidPartykitHost()) return;

    const fromMe = options.fromMe !== false;
    const messageTimestamp = options.messageTimestamp instanceof Date
        ? options.messageTimestamp.toISOString()
        : (options.messageTimestamp || new Date().toISOString());
    const content = options.content?.slice(0, 120);
    const shared = { messageId, organizationId, fromMe, content, conversationId };

    await Promise.all([
        postParty(`/parties/chat/${conversationId}`, {
            type: 'NEW_MESSAGE',
            ...shared,
            messageType: options.messageType,
            messageTimestamp,
        }),
        postPartykitOrgEvent(organizationId, 'status', {
            type: fromMe ? 'CONVERSATION_CHANGED' : 'NEW_MESSAGE_GLOBAL',
            ...shared,
        }),
    ]);
}
